import { useFormContext, useWatch } from 'react-hook-form';
import { ui } from '@procuros/datachecks';

import { useNavigationContext } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { DisplayModes } from 'services/webedi/types';
import { WebEDIAnnotation } from 'services/webediErrors/types';
import { DataDisplay } from 'components/Form/DataDisplay/DataDisplay';
import { SchemableFormInput } from 'components/Form/SchemableFormInput/SchemableFormInput';
import { Translate } from 'components/Translate/Translate';

type TextFieldProps = {
  field: ui.TextField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};

export const TextField = ({ field, fieldId, isReadOnly, mode, variant }: TextFieldProps) => {
  const value = useWatch({ name: fieldId });
  const { register } = useFormContext();
  const { service } = useNavigationContext<WebEDIAnnotation>();
  const fieldState = service.useFieldStateFromAnnotations(fieldId);
  const popoverItem = service.useItemByFieldPath(fieldId);
  const setCurrentItem = service.setCurrentItem;

  if (mode === DisplayModes.view) {
    return (
      <DataDisplay
        value={value}
        label={field.label}
        error={popoverItem}
        fieldId={fieldId}
        onShowFieldErrorModal={() => popoverItem && setCurrentItem(popoverItem)}
        description={field.description}
      />
    );
  }

  return (
    <SchemableFormInput
      type="text"
      label={field.label}
      description={field.description ? <Translate i18nKey={field.description} /> : undefined}
      error={popoverItem}
      {...register(fieldId)}
      value={value}
      onShowFieldErrorModal={() => popoverItem && setCurrentItem(popoverItem)}
      required={field.modality === 'MANDATORY'}
      disabled={isReadOnly}
      variant={variant}
      valueDescription={field.value_description}
      fieldState={fieldState}
    />
  );
};
